import { StrictMode } from 'react'
import { createRoot } from 'react-dom/client'
import '@/ds'
import '@/i18n'
import App from './App'
import { initMonitoring } from '@/lib/monitoring'

initMonitoring()

const root = document.getElementById('root')
if (!root) throw new Error('Falta #root en index.html')

createRoot(root).render(
  <StrictMode>
    <App />
  </StrictMode>,
)
